export default __webpack_public_path__ + "static/media/calendar-white.8b0019f7.svg";